import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../ui/Modal';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Modale de connexion
 */
const LoginModal = ({ isOpen, onClose, onSwitchToRegister, onSwitchToForgotPassword }) => {
  const { t } = useTranslation();
  const { signIn, signInWithProvider, resendConfirmationEmail, loading } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [emailNotConfirmed, setEmailNotConfirmed] = useState(false);
  const [confirmationSent, setConfirmationSent] = useState(false);

  // Validation du formulaire
  const validateForm = () => {
    const newErrors = {};
    
    if (!email.trim()) {
      newErrors.email = t('validation.emailRequired');
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = t('validation.emailInvalid');
    }
    
    if (!password) {
      newErrors.password = t('validation.passwordRequired');
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Gestion de la soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      setEmailNotConfirmed(false);
      setConfirmationSent(false);
      const result = await signIn(email, password);
      
      // Vérifier les différentes erreurs possibles
      if (result && result.error) {
        const errorMessage = result.error.message || '';
        
        if (errorMessage.toLowerCase().includes('email not confirmed')) {
          setEmailNotConfirmed(true);
          setErrors({ general: t('auth.emailNotConfirmed') });
        } else if (errorMessage.toLowerCase().includes('invalid login credentials')) {
          setErrors({ general: t('auth.invalidCredentials') });
        } else {
          // Erreur générique
          setErrors({ general: t('auth.loginError') });
        }
      } else if (result && result.success) {
        onClose();
      }
    }
  };

  const handleResendConfirmation = async () => {
    if (email && resendConfirmationEmail) {
      const result = await resendConfirmationEmail(email);
      if (result && result.success) {
        setConfirmationSent(true);
        setTimeout(() => setConfirmationSent(false), 5000);
      }
    }
  };

  // Gestion de la connexion via fournisseurs OAuth
  const handleProviderLogin = async (provider) => {
    await signInWithProvider(provider);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t('auth.login')}>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Boutons OAuth */}
        {/*<div className="space-y-3">
          <button 
            type="button"
            onClick={() => handleProviderLogin('google')}
            className="w-full flex items-center justify-center gap-2 bg-gris-clair border border-gray-300 text-gris-fonce px-4 py-2 rounded-md hover:bg-gray-50 transition"
            disabled={loading}
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
            {t('auth.loginWith')} Google
          </button>
          
          <button 
            type="button"
            onClick={() => handleProviderLogin('apple')}
            className="w-full flex items-center justify-center gap-2 bg-black text-white px-4 py-2 rounded-md hover:bg-gray-800 transition"
            disabled={loading}
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
            </svg>
            {t('auth.loginWith')} Apple
          </button>
        </div>
        
        <div className="relative my-4">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-300"></div>
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="px-2 bg-gris-clair text-gris-fonce/70">{t('auth.or')}</span>
          </div>
        </div>*/}
        
        {/* Message d'erreur général et email non confirmé */}
        {errors.general && (
          <div className="rounded-md bg-red-50 p-4">
            <div className="flex">
              <div className="ml-3">
                <h3 className="text-sm font-medium text-red-800">
                  {errors.general}
                </h3>
                {emailNotConfirmed && (
                  <div className="mt-2">
                    <button
                      type="button"
                      onClick={handleResendConfirmation}
                      className="text-sm font-medium text-red-600 hover:text-red-500 underline"
                      disabled={loading}
                    >
                      {t('auth.resendConfirmation')}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Message de confirmation envoyée */}
        {confirmationSent && (
          <div className="rounded-md bg-green-50 p-4">
            <div className="flex">
              <div className="ml-3">
                <p className="text-sm font-medium text-green-800">
                  {t('auth.confirmationEmailSent')}
                </p>
              </div>
            </div>
          </div>
        )}
        
        {/* Formulaire email/password */}
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gris-fonce mb-1">
            {t('auth.email')}
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (errors.email) setErrors({...errors, email: ''});
            }}
            className={`w-full px-3 py-2 border rounded-md shadow-sm ${
              errors.email ? 'border-red-500' : 'border-gray-300'
            } focus:outline-none focus:ring-2 focus:ring-bleu1`}
          />
          {errors.email && (
            <p className="mt-1 text-sm text-red-600">{errors.email}</p>
          )}
        </div>
        
        <div>
          <div className="flex items-center justify-between mb-1">
            <label htmlFor="password" className="block text-sm font-medium text-gris-fonce">
              {t('auth.password')}
            </label>
            <button
              type="button"
              onClick={onSwitchToForgotPassword}
              className="text-sm font-medium text-bleu1 hover:text-bleu3"
            >
              {t('auth.forgotPassword')}
            </button>
          </div>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              if (errors.password) setErrors({...errors, password: ''});
            }}
            className={`w-full px-3 py-2 border rounded-md shadow-sm ${
              errors.password ? 'border-red-500' : 'border-gray-300'
            } focus:outline-none focus:ring-2 focus:ring-bleu1`}
          />
          {errors.password && (
            <p className="mt-1 text-sm text-red-600">{errors.password}</p>
          )}
        </div>
        
        <button
          type="submit"
          className="w-full bg-bleu1 text-white py-2 px-4 rounded-md hover:bg-bleu3 transition"
          disabled={loading}
        >
          {loading ? t('common.loading') : t('auth.login')}
        </button>
      </form>
      
      <div className="mt-4 text-center">
        <p className="text-sm text-gris-fonce/80">
          {t('auth.newAccount')}
          <button
            type="button"
            onClick={onSwitchToRegister}
            className="ml-1 font-medium text-bleu1 hover:text-bleu3"
          >
            {t('auth.register')}
          </button>
        </p>
      </div>
    </Modal>
  );
};

export default LoginModal;
